import React from 'react';
import TextArea from '@wix/da-ds/pkg/formControls/dsPresets/TextArea';
var Textarea = React.forwardRef(function (_a, ref) {
    var label = _a.label, maxLength = _a.maxLength, error = _a.error, name = _a.name, placeholder = _a.placeholder, errorMessage = _a.errorMessage, id = _a.id, value = _a.value, defaultValue = _a.defaultValue, textareaClassName = _a.textareaClassName, rows = _a.rows, autoSize = _a.autoSize, onFocus = _a.onFocus, onBlur = _a.onBlur, onChange = _a.onChange, noBottomSpacing = _a.noBottomSpacing;
    var onKeyDown = function (e) {
        if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
            return;
        }
        var el = e.target;
        el.style.height = 'inherit';
        var computed = window.getComputedStyle(el);
        var desiredHeight = el.scrollHeight;
        for (var _i = 0, _a = [
            'border-top-width',
            'padding-top',
            'padding-bottom',
            'border-bottom-width',
        ]; _i < _a.length; _i++) {
            var k = _a[_i];
            desiredHeight += parseInt(computed.getPropertyValue(k), 10);
        }
        el.style.height = "".concat(desiredHeight, "px");
    };
    return (React.createElement(TextArea, { value: value || undefined, defaultValue: defaultValue || undefined, id: id !== null && id !== void 0 ? id : '', label: label !== null && label !== void 0 ? label : '', isLabelHidden: label === '' || label === undefined, ref: ref, name: name, rows: rows, validationResult: error || !!errorMessage ? 'error' : undefined, details: errorMessage || undefined, maxLength: maxLength, placeholder: placeholder, className: textareaClassName, onFocus: function (e) {
            onFocus && onFocus(e);
        }, onBlur: function (e) {
            onBlur && onBlur(e);
        }, onChange: function (e) {
            var v = e.target.value;
            onChange && onChange(v, e);
        }, onKeyDown: autoSize ? onKeyDown : undefined, noBottomSpacing: noBottomSpacing }));
});
Textarea.displayName = 'Textarea';
export default Textarea;
//# sourceMappingURL=Textarea.js.map